module.exports = __webpack_public_path__ + "static/media/moose-canoe-backdrop.d607c8da.png";